import { PublicationWallApp } from './PublicationWallApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

export const registerPublicationWallComponent = () => {
  registerReactWebComponent('content-publication-wall', PublicationWallApp, () => {
    return {};
  });
};
